<template>
  <div class="app-container">
    <NavTitle :title="title" />
    <div class="remote-content">
      <div class="remote-content-left">
        <div class="remote-content-left-title">连锁门店</div>
        <div class="remote-content-left-content" v-loading="loading">
          <div
            :class="[
              'remote-content-left-item',
              { active: v.storeId === activeStoreId },
            ]"
            v-for="v in stores"
            :key="v.storeId"
            @click="handleClick(v)"
          >
            <div class="remote-content-left-item-title">
              <span
                :class="['name', { active: v.storeId === activeStoreId }]"
                >{{ v.storeName }}</span
              >
              <span class="time">{{ v.updateTimeStr }}</span>
            </div>
            <div class="remote-content-left-item-value">
              <span class="address">{{ v.storeArea }}</span>
              <el-badge
                :value="v.preAuditCount"
                :max="99"
                class="item"
                v-if="v.preAuditCount > 0"
              >
              </el-badge>
            </div>
          </div>
          <div class="remote-content-left-empty" v-if="stores.length === 0">
            <img src="@/assets/layout/empty.png" alt="" class="empty-img" />
            <div class="empty-text">{{ message }}</div>
          </div>
        </div>
      </div>
      <div class="remote-content-right">
        <div class="remote-content-right-title">门店信息</div>
        <div
          :class="[
            'remote-content-right-content',
            { white: preAuditPrescriptions.length === 0 },
          ]"
          v-loading="loadingList"
        >
          <div
            class="remote-content-right-empty"
            v-if="preAuditPrescriptions.length === 0"
          >
            <img src="@/assets/layout/empty.png" alt="" class="empty-img" />
            <div class="empty-text">暂无处方信息</div>
          </div>
          <div
            class="remote-content-right-item"
            v-for="v in preAuditPrescriptions"
            :key="v.id"
          >
            <div class="remote-content-right-item-title">
              <span class="name">开具时间：</span>
              <span class="time">{{ v.issueTime }}</span>
            </div>
            <div
              class="remote-content-right-item-value"
              @click="handleRemoteClick(v)"
            >
              <div class="remote-content-right-item-value-left">
                <img src="@/assets/remote/icon.png" alt="" class="img" />
                <span class="right-button">查看处方</span>
              </div>
              <div class="remote-content-right-item-value-right">
                <div class="remote-content-right-item-value-right-item">
                  <div class="name">姓名</div>
                  ：
                  <EllipsisTooltip :content="v.userName" class="value">
                    {{ v.userName }}
                  </EllipsisTooltip>
                </div>
                <div class="remote-content-right-item-value-right-item">
                  <div class="name">性别</div>
                  ：
                  <EllipsisTooltip :content="v.userSex" class="value">
                    {{ v.userSex }}
                  </EllipsisTooltip>
                </div>
                <div class="remote-content-right-item-value-right-item">
                  <div class="name">年龄</div>
                  ：
                  <EllipsisTooltip :content="v.userAge" class="value">
                    {{ v.userAge }}
                  </EllipsisTooltip>
                </div>
                <div class="remote-content-right-item-value-right-item">
                  <div class="name">处方类型</div>
                  ：
                  <EllipsisTooltip :content="v.issueType" class="value">
                    {{ v.issueType }}
                  </EllipsisTooltip>
                </div>
                <div class="remote-content-right-item-value-right-item">
                  <div class="name">科别</div>
                  ：
                  <EllipsisTooltip :content="v.department" class="value">
                    {{ v.department }}
                  </EllipsisTooltip>
                </div>
                <div class="remote-content-right-item-value-right-item">
                  <div class="name">药品信息</div>
                  ：
                  <EllipsisTooltip
                    :content="String(v.drugDetailCount)"
                    class="value"
                  >
                    {{ v.drugDetailCount }}
                  </EllipsisTooltip>
                </div>
                <div
                  class="remote-content-right-item-value-right-item"
                  style="width: 100%"
                >
                  <div class="name" style="width: 10%">诊断</div>
                  ：
                  <div
                    style="font-weight: 400; font-size: 14px; color: #1e2129"
                  >
                    {{ v.diagnose }}
                  </div>
                </div>
              </div>
            </div>
            <div class="remote-content-right-item-value-time">
              <div class="item-value-time-left">
                <div class="time-left-item">
                  <span>提交人：</span>
                  <span style="color: #1e2129">{{ v.submitUserName }}</span>
                </div>
                <div class="time-left-item">
                  <span>提交时间：</span>
                  <span style="color: #1e2129">{{ v.submitTime }}</span>
                </div>
              </div>
              <div>
                <span>已等待：</span>
                <span style="color: #ff2121">{{
                  formatWaitTime(v.waitTime)
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="remote-content-user-box" v-if="userList.length > 0">
        <div class="user-video">
          <img src="@/assets/remote/video.png" alt="" class="video-img" />
          <div class="user-video-text">暂未开启</div>
        </div>
        <div class="user-list">
          <div class="user-list-title">机构人员</div>
          <div class="user-list-content">
            <div
              class="user-list-content-item"
              v-for="item in userList"
              :key="item.userName"
            >
              <div class="user-list-content-item-name-box">
                <div class="item-name">{{ item.userName }}</div>
                <div
                  :class="[
                    'item-status',
                    { blue: item.onlineState === '离岗' },
                  ]"
                >
                  {{ item.onlineState }}
                </div>
              </div>
              <div class="user-list-content-item-job-box">
                <div
                  class="item-job"
                  v-for="itemStations in item.userStations"
                  :key="itemStations"
                >
                  {{ itemStations }}
                </div>
              </div>
              <div class="user-list-content-item-time">
                {{ item.signedName }}：{{ item.signedTime }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <DetailPrescription ref="DetailPrescriptionDetailRef" @submit="fetchList" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import EllipsisTooltip from "@/components/EllipsisTooltip";
import DetailPrescription from "./components/detailPrescription.vue";
import NavTitle from "@/components/NavTitle/index.vue";
import wsManager from "@/utils/websocket";
import { getToken as getAuthToken } from "@/utils/auth";

export default {
  name: "Remote",
  components: { EllipsisTooltip, DetailPrescription, NavTitle },
  // beforeRouteEnter(to, from, next) {
  //   console.log("进入页面 from:", from.path);
  //   next();
  // },
  // beforeRouteLeave(to, from, next) {
  //   console.log("离开页面 to:", to.path);
  //   next();
  // },
  data() {
    return {
      title: ["远程审方"],
      barcode: "",
      queryParam: {},
      loading: false,
      loadingList: false,
      stores: [],
      activeStoreId: "",
      preAuditPrescriptions: [],
      timer: null,
      message: "",
      userList: [],
    };
  },
  computed: {
    ...mapState("websocket", ["chainStoreList", "preAuditPrescriptionList"]),
  },
  watch: {
    chainStoreList: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.stores = JSON.parse(newVal);
        }
      },
      immediate: true,
    },
    preAuditPrescriptionList: {
      handler(newVal) {
        if (newVal) {
          this.preAuditPrescriptions.unshift(newVal);
          this.startTimer();
        }
      },
      immediate: true,
    },
  },
  created() {},
  mounted() {
    this.fetchData();
  },
  beforeDestroy() {
    this.stopTimer();
    this.closeWebSocket();
  },
  methods: {
    handleRemoteClick(v) {
      this.$refs.DetailPrescriptionDetailRef.show(v);
    },
    formatWaitTime(timeStr) {
      if (!timeStr) return "00:00";
      if (typeof timeStr === "number") {
        const num = timeStr;
        const hours = Math.floor(num / 3600);
        const minutes = Math.floor((num % 3600) / 60);
        const secs = num % 60;
        if (hours > 0) {
          return `${hours.toString().padStart(2, "0")}:${minutes
            .toString()
            .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
        }
        return `${minutes.toString().padStart(2, "0")}:${secs
          .toString()
          .padStart(2, "0")}`;
      }
      return timeStr;
    },
    parseTimeToSeconds(timeStr) {
      if (!timeStr || typeof timeStr !== "string") return 0;
      const parts = timeStr.split(":").map((p) => parseInt(p, 10) || 0);
      if (parts.length === 3) {
        return parts[0] * 3600 + parts[1] * 60 + parts[2];
      } else if (parts.length === 2) {
        return parts[0] * 60 + parts[1];
      }
      return 0;
    },
    formatSecondsToTime(seconds) {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;
      return `${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
    },
    startTimer() {
      if (!this.preAuditPrescriptions.length) return;
      this.stopTimer();
      this.timer = setInterval(() => {
        this.preAuditPrescriptions.forEach((item, index) => {
          if (item.waitTime) {
            const seconds = this.parseTimeToSeconds(item.waitTime) + 1;
            this.$set(this.preAuditPrescriptions, index, {
              ...item,
              waitTime: this.formatSecondsToTime(seconds),
            });
          }
        });
      }, 1000);
    },
    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    closeWebSocket() {
      console.log("关闭 WebSocket 连接");
      wsManager.close();
    },
    openWebSocket() {
      const token = getAuthToken();
      wsManager.connect(token);
    },
    handleClick(v) {
      this.activeStoreId = v.storeId;
      this.fetchList();
    },
    async fetchList() {
      this.loadingList = true;
      const { data } = await this.$api.prescription.GetPreAuditPrescriptions({
        enterpriseId: this.activeStoreId,
      });
      this.preAuditPrescriptions = data.prescriptionList || [];
      this.userList = data.userList || [];
      this.loadingList = false;
      this.startTimer();
    },
    async fetchData() {
      this.loading = true;
      const { data } =
        await this.$api.prescription.GetPrescriptionChainStores();
      this.stores = data.stores || [];
      this.message = data.message || "";
      this.loading = false;
      this.openWebSocket();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
